module.exports = __webpack_public_path__ + "static/media/meat.c993dc98.webp";